import { render, staticRenderFns } from "./CompaniesContainer.vue?vue&type=template&id=0f85bc12&scoped=true"
import script from "./CompaniesContainer.vue?vue&type=script&lang=js"
export * from "./CompaniesContainer.vue?vue&type=script&lang=js"
import style0 from "./CompaniesContainer.vue?vue&type=style&index=0&id=0f85bc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f85bc12",
  null
  
)

export default component.exports